module.exports = __webpack_public_path__ + "static/media/LeopardFragments.27872e92.png";